import api from './api';
import type { EventLogEntry } from '../types/council';

export interface EventLogPage {
  entries: EventLogEntry[];
  has_more: boolean;
  oldest_seq: number | null;
  newest_seq: number | null;
}

export async function getEventLog(
  sessionId: string,
  params: { before_seq?: number; after_seq?: number; limit?: number } = {},
): Promise<EventLogPage> {
  const { data } = await api.get<EventLogPage>(
    `/sessions/${sessionId}/event-log`, { params });
  return data;
}
